module.exports = __webpack_public_path__ + "img/Imagem_6.1c144536.png";